export function kliknalPrzyciskZobaczTenProduktWZestawie() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest(
            '[data-ga-event-kliknal-przycisk-zobacz-ten-produkt-w-zestawie]'
        );
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const productUrl = target.getAttribute('href') || '';

        const productCode =
            document.querySelector('#hero-title')?.textContent.trim() || '';

        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;

        const clickedProductCode = target.getAttribute(
            'data-product-code'
        ) || '';

        window.dataLayer.push({
            event: 'kliknal_przycisk_zobacz_ten_produkt_w_zestawie',
            product_code: productCode,
            product_url: currentUrl,
            clicked_product_url: productUrl,
            clicked_product_code: clickedProductCode,
        });
    });
}
